const KeenSlider = window.KeenSlider

const { setInitialised, useDots } = window.BAO.Carousel.plugins

class ProductMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 768px)': {
            disabled: true,
          },
        },
        slideChanged: this.onSlideChanged,
      },
      [setInitialised(), useDots(this.els?.dot?.elements)],
    )
  }

  onSlideChanged (instance) {
    if (!this.els?.slide?.exists) return

    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-current', index === currentSlide)
    })
  }
}

if (!customElements.get('product-media')) {
  customElements.define('product-media', ProductMedia)
}
